import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";
export default {
  components: {
    TogglesForm
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.handleSettingsUserChange();
  },
  computed: {
    //move to mixin
    ...mapGetters({
      user: "user/user"
    })
  },
  beforeMount() {
    this.setUpToggles();
  },
  methods: {
    setUpToggles() {
      this.toggles.forEach(aToggle => {
        if (this.settingsUser.hasOwnProperty(aToggle.property)) {
          aToggle.value = this.settingsUser[aToggle.property];
        }
      });
    },
    handleToggleChange(event) {
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        this.settingsUser[checkedId] = event.target.checked
          ? event.target.checked
          : false;
      }
      this.handleSettingsUserChange(this.settingsUser);
    },
    handleSettingsUserChange() {
      //can be a mixin
      //this.$emit("settings-user-changed", settings);
      const payload = {
        settingsUser: this.settingsUser,
        toolId: this.resource.toolId
      };
      this.$store.dispatch("tools/setSettingsUserForTool", payload);
    },
    handleUpdateUserData(userDataPayload) {
      debugger;
      this.$emit("update-user-data", userDataPayload);
    }
  },
  data() {
    return {
      settingsUser: {},
      toggles: []
    };
  }
};
